import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    computePath,
    CurrentAttachmentVersionDto,
    DisplayNotice,
    LocationDetailsDto,
    MissionNoticeDto,
    NoticeDto,
    Organisation
} from '@flyfreely-portal-ui/flyfreely';
import { getFeatureGroups } from '@flyfreely-portal-ui/locations';
import { SitesDataService } from '@flyfreely-portal-ui/sites-shared';
import bbox from '@turf/bbox';
import { BBox } from 'geojson';
import { mergeFeatureCollectionWithSprites } from 'libs/map/src/lib/flyfreely-map/helpers';
import { FeatureGroup, MapDataInput } from 'libs/map/src/lib/index';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, Subject } from 'rxjs';
import {
    formatLotamAudience,
    formatLotamPriority,
    formatOperatingRequirement
} from '../lotam-data.service';

@Component({
    selector: 'lotam-details',
    templateUrl: './lotam-details.component.html',
    styleUrls: ['./lotam-details.component.scss'],
    providers: [SitesDataService]
})
export class LotamDetailsComponent implements OnInit, OnDestroy {
    downloadUrlFn = (attachment: CurrentAttachmentVersionDto) => {
        return computePath(
            `/webapi/notices/${this.lotam?.id}/attachments/${attachment.id}`,
            {
                managingOrganisationId: this.organisation?.id,
                attachmentVersionId: attachment.attachmentVersionId
            }
        );
    };
    @Input() lotam?: DisplayNotice;
    @Input() organisation: Organisation;
    @Input() missionLocation?: LocationDetailsDto;
    /** When viewing a LOTAM in the context of a mission, the mission-specific status of the notice. */
    @Input() missionStatus?: MissionNoticeDto.Status;
    @Input() isAcknowledged: boolean;

    mapData$ = new BehaviorSubject<MapDataInput>({});
    missionLocationFeatures$ = new BehaviorSubject<FeatureGroup[] | null>(null);

    noticeBoundingBox?: BBox;

    private ngUnsubscribe$ = new Subject<void>();

    constructor(private modal: BsModalRef<LotamDetailsComponent>) {}

    ngOnInit(): void {
        if (this.lotam?.displayLocation != null) {
            const features = mergeFeatureCollectionWithSprites([
                this.lotam?.displayLocation
            ]);

            this.noticeBoundingBox = bbox(features.featureCollection);

            this.mapData$.next({
                LOTAM: features
            });
        }
        if (this.missionLocation != null) {
            const features = getFeatureGroups(
                this.missionLocation.features,
                0,
                2
            ).features;
            this.missionLocationFeatures$.next(features);
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.mapData$.complete();
        this.missionLocationFeatures$.complete();
    }

    protected readonly formatLotamPriority = formatLotamPriority;
    protected readonly formatAudience = formatLotamAudience;
    protected readonly formatOperatingRequirement = formatOperatingRequirement;

    get hasLocation() {
        return this.lotam != null && this.lotam.displayLocation != null;
    }

    cancel() {
        this.modal.hide();
    }

    protected readonly NoticeDto = NoticeDto;
}
